export const GENDER = 'Gender';
export const MARITAL_STATUS = 'Marital Status';
export const CHILDREN_STATUS = 'Presence of Children in the Household';
export const HOMEOWNERSHIP = 'Homeownership';
export const EDUCATION = 'Education';
export const PETS = 'Pets';
export const AGE_RANGE = 'Age Range';
export const HOUSEHOLD_INCOME = 'Household Income';
